import React from "react";
import AddProperty from "../properties/AddProperty";
const AddProperyForm = () => {
  return (
    <>
      <AddProperty />
    </>
  );
};

export default AddProperyForm;
